import { forwardRef } from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import type { InputTextProps } from './types';
import { Input } from '../Input';
import { FormControl } from '../FormControl';
import { FormLabel } from '../FormLabel';
import { FormErrorMessage } from '../FormErrorMessage';

export const InputText = forwardRef<HTMLInputElement, InputTextProps>(({ 
  label,
  errorMessage,
  type = 'text',
  formControlProps,
  rightIcon,
  onRightIconClick,
  isRightIconDisabled = false,
  ...props
}, ref) => {
  return (
    <FormControl isInvalid={!!errorMessage} {...formControlProps}>
      <Box position="relative">
        <Input 
          translate="no" 
          type={type} 
          isInvalid={!!errorMessage} 
          paddingRight={rightIcon ? "48px" : "16px"}
          ref={ref}
          {...props} 
        />
        <FormLabel>{label}</FormLabel>
        {rightIcon && (
          <IconButton
            aria-label="right-icon"
            icon={rightIcon}
            variant="ghost"
            size="sm"
            isDisabled={isRightIconDisabled}
            onClick={onRightIconClick}
            position="absolute"
            right="16px"
            top="50%"
            transform="translateY(-50%)"
            zIndex={1}
          />
        )}
      </Box>
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  );
});

InputText.displayName = 'InputText';
